<div class="top-bar">
  <h1 class="top-bar__title">{{ 'NEW_MISSION.TITLE' | translate }}</h1>
  <app-select-market></app-select-market>
</div>

<div class="page">
  @if (selectedMarket) {
    <div class="card mission-create-ctn">
      <div class="card__header">
        <div>
          <div class="card__title">{{ 'UI.NEW_MISSION.TITLE' | translate }}</div>
          <div class="page-subtitle">{{ 'UI.NEW_MISSION.TEXT' | translate }}</div>
        </div>
      </div>
      <div class="step">
        <span class="step__number">1</span>
        <span class="step__label">Select location</span>
        <div class="location-selector">
          <df-form-field label="Search all locations">
            <df-select inputId="globalLocation" placeholder="Search corporation, refinery, or unit"
              ariaLabel="Search all locations" searchPlaceholder="Type a corporation, refinery, or unit"
              [searchable]="true" [clearable]="false" [options]="locationOptions" [formControl]="rruFC" />
          </df-form-field>
          <p class="location-selector__divider">Or select each field</p>
          <div class="rru-fields">
            <df-form-field id="refineryCorporation" [label]="'UI.NEW_MISSION.REFINERY_CORPORATION' | translate">
              <df-select inputId="refineryCorporation" [placeholder]="'UI.SELECT' | translate"
                [options]="refineryCorporationOptions" [formControl]="refineryCorporationFC" />
            </df-form-field>
            <df-form-field id="refinery" [label]="'UI.NEW_MISSION.REFINERY' | translate">
              <df-select inputId="refinery" [placeholder]="'UI.SELECT' | translate"
                [options]="refineryOptions" [formControl]="refineryFC" />
            </df-form-field>
            <df-form-field id="unit" [label]="'UI.NEW_MISSION.UNIT_FIELD' | translate">
              <df-select inputId="unit" [placeholder]="'UI.SELECT' | translate"
                [options]="unitOptions" [formControl]="unitFC" />
            </df-form-field>
          </div>
        </div>
      </div>
      <div class="step" [class.step--disabled]="questionnaireIdFC.disabled">
        <span class="step__number">2</span>
        <label for="retrieveData" class="step__label">{{ 'UI.NEW_MISSION.QUESTIONNAIRE' | translate }}</label>
        <df-form-field class="questionnaire-field" id="retrieveData">
          <df-select inputId="retrieveData"
            placeholder="Select an existing questionnaire from the list"
            ariaLabel="Questionnaire"
            [options]="(questionnaireOptions$ | async) ?? []"
            [formControl]="questionnaireIdFC" />
        </df-form-field>
      </div>
      <div class="step step--last" [class.step--disabled]="!(selectedData$ | async)?.preparationPk">
        <span class="step__number">3</span>
        <span class="step__label">{{ 'UI.NEW_MISSION.DATA' | translate }}</span>
        @if ((selectedData$ | async)?.preparationPk) {
          <div class="form-content">
            <section class="injection-orders" aria-label="Injection orders">
              <div class="injection-orders__header">
                <div>
                  <h2>Injection orders</h2>
                  <p>Add each product and train combination planned for this mission.</p>
                </div>
                <df-button variant="secondary" icon="heroPlusCircle" (onClick)="addInjectionRow()">
                  Add product order
                </df-button>
              </div>
              @for (row of injectionRows.controls; track $index; let index = $index) {
                <div class="injection-order-row">
                  <df-form-field [label]="'UI.NEW_MISSION.TRAIN' | translate">
                    <df-select [inputId]="'injection-train-' + index" [placeholder]="'UI.SELECT' | translate"
                      [options]="trainOptions" [formControl]="$any(row.get('trainpk'))" />
                  </df-form-field>
                  <df-form-field label="Product"
                    [errors]="productErrors(index)" [touched]="$any(row.get('productPk')).touched" [dirty]="$any(row.get('productPk')).dirty">
                    <df-select [inputId]="'injection-product-' + index" placeholder="Select a product"
                      [searchable]="false" [options]="productOptionsForRow(index, (productOptions$ | async) ?? [])"
                      [compareWith]="compare" [formControl]="$any(row.get('productPk'))" />
                  </df-form-field>
                  <app-arkema-input-with-unit class="injection-order-row__quantity"
                    [labelId]="'injection-quantity-' + index" label="Quantity"
                    [controlFC]="$any(row.get('quantity'))"
                    [unitControlFG]="$any(row.get('quantityUnit'))"
                    [unitList]="DMDS_QUANTITY_UNIT_LIST"
                    [minValue]="VALIDATOR_MIN_DMDS_QTY" [maxValue]="VALIDATOR_MAX_DMDS_QTY"
                    [hint]="'including contingency'" />
                  @if (requiresCatalystWeight(index)) {
                    <app-arkema-input-with-unit class="injection-order-row__catalyst-weight"
                      [labelId]="'injection-catalyst-weight-' + index" label="Catalyst weight"
                      [controlFC]="$any(row.get('catalystWeight'))"
                      [unitControlFG]="$any(row.get('catalystWeightUnit'))"
                      [unitList]="CATALYST_WEIGHT_UNIT_LIST"
                      [minValue]="VALIDATOR_MIN_CATALYST_WEIGHT"
                      [maxValue]="VALIDATOR_MAX_CATALYST_WEIGHT"
                      [required]="true" [hint]="''" />
                  }
                  <df-button variant="primary" size="lg" danger [isIconOnly]="true"
                    icon="heroTrash" ariaLabel="Remove product order"
                    [disabled]="injectionRows.length <= 1" (onClick)="removeInjectionRow(index)" />
                </div>
              }
              @if (injectionRows.hasError('duplicateTrainProduct')) {
                <p class="injection-orders__error">A product can only be ordered once per train.</p>
              }
            </section>
            <df-form-field class="block date-picker" id="sulfidingDate" label="Estimated sulfiding date"
              [helpText]="sulfidingDateFC?.value ? (sulfidingDateFC.value | date:'EEEE') : ''"
              [errors]="sulfidingDateErrors()" [touched]="sulfidingDateFC.touched" [dirty]="sulfidingDateFC.dirty">
              <df-date-field id="sulfidingDate" [formControl]="sulfidingDateFC" />
            </df-form-field>
          </div>
          <div class="form-button">
            <df-button variant="primary" icon="heroPlusCircle"
              [loading]="(creating$ | async) === true"
              [disabled]="form.invalid" (onClick)="onValidateNewMissionClickHandler()">
              {{ 'UI.NEW_MISSION.CREATE' | translate }}
            </df-button>
          </div>
        }
      </div>
    </div>
  }
</div>
